export default __webpack_public_path__ + "81e5147c70972877aa5cbaf2d9ca94cb.png";